import React from 'react';
import { useIsEmbeddedMobile } from '../../../_hooks/useIsEmbeddedMobile';
import { SummaryMobile } from './components/SummaryMobile/SummaryMobile';
import { DesktopWidgets } from '../../components/DesktopWidgets/DesktopWidgets';
import { TabSlug } from '../../types';

export const Summary = () => {
  const isEmbeddedMobile = useIsEmbeddedMobile();

  if (isEmbeddedMobile) {
    return <SummaryMobile />;
  }

  return <DesktopWidgets tab={TabSlug.Summary} />;
};
